import React from 'react';

const CloseIcon: React.FC<{className?: string}> =({className}) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
        <path style={{stroke: 'var(--secondary-color)'}} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1l15.5 15.5M16.5 1L1 16.5"/>
    </svg>
);

export default CloseIcon;